import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useRfqAccess } from '@/hooks/useRfqAccess';
import { canAccessRfq, type Role } from '@/types/navigation';

/** Direct /rfq URLs use the same predicate as the navigation registry:
 * admin/manager always, traders only with a resolved `rfqAccess` grant.
 * Revoking the grant rerenders this guard and ejects an open RFQ page. */
export function RfqRoute() {
  const role = (useAuthStore((s) => s.user?.role) ?? 'trader') as Role;
  const rfqAccess = useRfqAccess();
  return canAccessRfq(role, rfqAccess) ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
